var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: `booking-element--error ${_vm.type}` }, [
    _c("img", { attrs: { src: "/images/icons_svg/info-icon.svg" } }),
    _vm._v(
      _vm._s(_vm.$t(`booking.element_errors.${_vm.msg}`, this.msgOptions)) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }